// /home/szymon/kreator2/frontend/src/components/PdfEditorTemplates.js
// v1.0.0 – Edytor PDF dla szablonów (TemplateCollections).

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Editor from './Editor';

/**
 * Ten plik działa analogicznie do PdfEditor.js,
 * tylko że pobiera dane z /admin/templates/:id,
 * a nie z /admin/orders/:id.
 *
 * Również tutaj przekazujemy pdfData i fileObjId do <Editor/>.
 * Po zakończeniu wracamy do /admin/templates/:id
 */

export default function PdfEditorTemplates({ backendUrl }) {
  const { id, downloadKey } = useParams();
  const navigate = useNavigate();

  const [pdfData, setPdfData] = useState(null);
  const [fileObjId, setFileObjId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Ładujemy pdfData i fileObjId dla TemplateCollection
  useEffect(() => {
    let isMounted = true;

    (async () => {
      try {
        setLoading(true);
        setError('');

        // Pobierz dane kolekcji
        const res = await fetch(`${backendUrl}/admin/templates/${id}`, {
          credentials: 'include'
        });
        if (!res.ok) {
          throw new Error(`Błąd pobierania kolekcji (status=${res.status})`);
        }
        const collData = await res.json();
        if (!isMounted) return;

        // Znajdź w pdfMetadatas => pdfJson
        const metaObj = (collData.pdfMetadatas || []).find(
          (m) => m.downloadKey === downloadKey
        );
        if (!metaObj) {
          throw new Error(`Brak metadanych PDF (downloadKey=${downloadKey})`);
        }
        const pdfJson = metaObj.metadata;
         if (!pdfJson || !pdfJson.pages || pdfJson.pages.length === 0) {
            throw new Error('Brak stron w PDF (pdfJson.pages)');
         }

         // Ustawiamy pdfData bezpośrednio z metadanych pobranych z backendu
         // (Backend powinien już zwracać poprawne, względne ścieżki w polu 'src')
         setPdfData(pdfJson);

         // Znajdź w files => fileObj => fileObj.id => projectId
         const fileObj = (collData.files || []).find(
          (f) => f.downloadKey === downloadKey
        );
        if (!fileObj) {
          throw new Error('Nie znaleziono pliku w collData.files.');
        }
        setFileObjId(fileObj.id);

      } catch (ex) {
        console.error('[PdfEditorTemplates] =>', ex);
        if (isMounted) {
          setError(ex.message);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [backendUrl, id, downloadKey]);

  // Funkcja powrotu => przenosi do TemplateDetails
  const handleGoBack = () => {
    navigate(`/admin/templates/${id}`);
  };

  if (loading) {
    return <div style={{ padding: 20 }}>Wczytywanie edytora PDF...</div>;
  }
  if (error) {
    return (
      <div style={{ padding: 20, color: 'red' }}>
        <p>ERROR: {error}</p>
        <button onClick={handleGoBack}>Wróć</button>
      </div>
    );
  }
  if (!pdfData || !fileObjId) {
    return (
      <div style={{ padding: 20 }}>
        <p>Brak pdfData lub fileObjId.</p>
        <button onClick={handleGoBack}>Wróć</button>
      </div>
    );
  }

  // Render samego Editor, bez nagłówka i przycisku "Wróć" w body
  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <Editor
        backendUrl={backendUrl}
         pdfData={pdfData}
         projectId={fileObjId} // To jest ID pliku szablonu, nie projektu
         onGoBack={handleGoBack}
         isTemplateEditor={true} // Dodajemy flagę
       />
    </div>
  );
}
